export default {
    loading: 'widthAndConnect:loading',
    search: 'widthAndConnect:search',
    agentCurveData: 'widthAndConnect:agentCurveData',
    widthData: 'widthAndConnect:widthData',
    connectData: 'widthAndConnect:connectData',
    multiCurveData: 'widthAndConnect:multiCurveData',
    pieData: 'widthAndConnect:pieData',
    agents: 'widthAndConnect:agents',
    areas: 'widthAndConnect:areas',
    bandwidthDetail:'widthAndConnect:bandwidthDetail',
    agentSort:'widthAndConnect:agentSort'

}


// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/widthAndConnect/constant.js